<template>
  <div class="container-flued homeSlide1">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 leftSide">
          <h2>YOUR IDEAL</h2>
          <h5>
            OUTSOURCING <br />
            PARTNER
          </h5>
          <p>
            Maximize Your Company's Revenue With Our Proven Lead Generation
            Services
          </p>

          <!-- <a href="#" class="yellowButton">Get Your Quote</a> -->
        </div>
        <div class="col-lg-6 rightSide">
          <div class="row">
            <div class="col-lg-12 circle1">
              <img src="@/assets/mainImg.png" class="slideImg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="container-flued homeSlide1">
    <div class="row">
      <div class="col-12">
        <h2>"Stay Prepared, Stay Protected</h2>
        <h5>Insurance for Life's Uncertainties"</h5>
        <h6>Your Shield in an Uncertain World"</h6>
        <a href="#" class="yellowButton">Get Your Quote</a>
      </div>
    </div>
  </div> -->
  <!--container-->
</template>

<script>
export default {
  name: 'HomeSlider',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lan="scss">
.homeSlide1 {
  background: linear-gradient(
    99deg,
    #292341 -5.28%,
    rgba(0, 52, 120, 0.26) 149.21%
  );
  padding-bottom: 40px;
}
h2 {
  color: #f5f5f5;
  font-family: Inter;
  font-size: 80px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-shadow: 2px 4px 3px rgba(0, 0, 0, 0.2),
    0px -4px 5px rgba(255, 255, 255, 0.2);
  margin-top: 80px;
  animation: 0.5s ease-in 0s 1 slideInFromLeft;
}
h5 {
  color: #f5f5f5;
  font-family: Futura Hv BT;
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  animation: 0.7s ease-in 0s 1 slideInFromLeft;
  font-family: Inter;
  padding-top: 5px;
}
p {
  color: #f5f5f5;
  font-family: Futura Bk BT;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  animation: 0.9s ease-in 0s 1 slideInFromLeft;
  font-family: Inter;
}
.leftSide {
  .row {
    margin-right: 0px;
  }
  .yellowButton {
    width: 220px;
    margin: 0 auto;
    display: block;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 50px;
    animation: 1.1s ease-in 0s 1 slideInFromLeft;
  }
}
.circle1 {
  animation: 0.8s ease-in 0s 1 slideInFromLeft;
  margin-top: 40px;
}
.slideImg {
  width: 100%;
}

@keyframes slideInFromLeft {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* @media screen and (min-width: 1500px) {
  .homeSlide1 {
    h5 {
      text-align: center;
    }
  }
} */
@media screen and (max-width: 1200px) {
  h2 {
    font-size: 48px;
  }
  h5 {
    font-size: 32px;
  }
  h6 {
    font-size: 24px;
  }
}

@media screen and (max-width: 992px) {
  .getQouteA {
    width: 160px;
    margin: 0 auto;
    margin-top: 10px;
    background-color: #ffc93c;
  }
  h2 {
    font-size: 48px;
    margin-top: 40px;
  }
  h5 {
    font-size: 48px;
    width: 100%;
    /* text-align: center; */
  }
  h6 {
    font-size: 32px;
  }
  .circle1 {
    width: 100%;
    img {
    }
  }
  .slideImg {
    width: 450px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
}
@media screen and (max-width: 540px) {
  .hideOnMobile {
    display: none;
  }

  h2 {
    font-size: 32px;
    margin-top: 40px;
  }
  h5 {
    font-size: 32px;
    width: 100%;
    /* text-align: center; */
  }
  h6 {
    font-size: 24px;
  }
  .slideImg {
    width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
}
</style>
